import { render, staticRenderFns } from "./NativeBoard.vue?vue&type=template&id=f21d6804&"
import script from "./NativeBoard.vue?vue&type=script&lang=js&"
export * from "./NativeBoard.vue?vue&type=script&lang=js&"
import style0 from "./NativeBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports